const FONT_FACES = [
  {weight: 400, file: '/assets/fonts/inter-regular.woff2'},
  {weight: 700, file: '/assets/fonts/inter-bold.woff2'},
];

/** `@font-face` rules registering the bundled built-in composition font under `family`. */
export const getBuiltInFontFaceRules = (family: string) =>
  FONT_FACES.map(
    (face) =>
      `@font-face { font-family: '${family}'; font-weight: ${face.weight}; font-style: normal; font-display: swap; src: url('${face.file}') format('woff2'); }`
  ).join('\n');
